import { createContext } from 'react'

import type { ChamberDetail } from './chamberScene.ts'

/**
 * **지금 도는 모듈의 세부 국면**(`ChamberDetail.step`) — 어셈블러 `UV` 같은 것. 🔴 **값은 화면 컨테이너가 서버 모듈
 * 상태에서 만든다**(`screens/monitoring/chamberMotion.ts`). 이 층은 서버 상태 이름을 모른다.
 * 컨텍스트로 두는 까닭: 카드 격자 · 서랍 · 장비 탭이 **같은 사실 하나**를 받는다 — 챔버마다 흘려 넘기면
 * 한 곳이 빠지는 날 카드는 UV, 서랍은 누름을 그린다.
 * ⚠ 없으면(`undefined`) 그 단계의 기본 도구가 선다.
 * ⚠ 파일 이름의 «등록소»는 3D 시절(캔버스 한 장이 챔버 자리를 모으던 등록소)의 흔적이다. 3D 를 걷으며
 *   (2026-10-01) 등록소는 지웠고 이 컨텍스트만 남았다 — 부르는 쪽(`MonitoringContainer`)을 흔들지 않으려고 자리를 그대로 두었다.
 */
export const ChamberStepContext = createContext<ChamberDetail['step']>(undefined)

/**
 * **염색기 피펫이 «지금» 들어가 있는 웰**(eric 2026-10-12 「분주할 때.. 피펫 넣는 거 표현해줘」) — 값은 화면 컨테이너가 서버 사실로 만든다:
 * 염색기의 지금 · 방금 끝난 동작이 «챔버 자리» 동작(분주 · 흡입 · 혼합)일 때만, 그 칸은 트레이 뷰의 ▶ 한 칸 · 없으면 가장 최근 분주 기록의 칸
 * (장비 판 정면도와 같은 규칙 · `stainFrontModel.ts`). 시약 랙 · 폐기통 · 팁 랙 · 이동이면 `null` — 어느 챔버에도 피펫이 없다.
 * ⚠ 없으면(`null`) 어느 챔버에도 스포이드가 서지 않는다(짐작하지 않는다).
 */
export const StainPipetteWellContext = createContext<string | null>(null)
